import React from 'react';
import { CardContainer } from '@welbe/web-design-system';

import {
	Container,
	DefaultImage,
	PreviewContainer,
	Image,
	ImageLabelContainer,
	ObjectContainer,
	PdfObject,
	PreventScrollObject,
	MessageBody,
	ActionContainer,
	TitleContainer,
	Title,
	SubTitle,
	IconContainer,
	EmptyText,
	EmptyIcon,
} from './Card.styles';

export type CardProps = {
	file?: string;
	fileLabel?: string;
	fileExtension?: string;
	messageBody?: string;
	title?: string;
	subTitle?: string;
	icon?: React.ReactNode;
	loading?: boolean;
	handleAction?: () => void;
};

export const Card = ({
	file,
	fileLabel,
	fileExtension,
	messageBody,
	title,
	subTitle,
	icon,
	loading,
	handleAction,
}: CardProps): JSX.Element => {
	const renderObjectImg = (file: string) => {
		const isDefaultImg = Boolean(fileExtension);

		const objectImg = () =>
			isDefaultImg ? (
				<Image image={file} />
			) : (
				<DefaultImage src={file} alt="preview" />
			);

		return (
			<>
				{fileExtension !== 'pdf' ? (
					objectImg()
				) : (
					<ObjectContainer>
						<PdfObject data={`${file}#zoom=35`} type="application/pdf" />
						<PreventScrollObject />
					</ObjectContainer>
				)}
			</>
		);
	};
	const renderCustomTemplate = () => {
		return file ? (
			renderObjectImg(file)
		) : (
			<MessageBody>{messageBody}</MessageBody>
		);
	};

	return (
		<CardContainer type={'horizontal'}>
			<Container>
				<PreviewContainer>
					<>
						{!loading && renderCustomTemplate()}
						{fileLabel && (
							<ImageLabelContainer>{fileLabel}</ImageLabelContainer>
						)}
					</>
				</PreviewContainer>
				<ActionContainer>
					<TitleContainer>
						{!loading ? (
							<>
								{title && <Title>{title}</Title>}
								{subTitle && <SubTitle>{subTitle}</SubTitle>}
							</>
						) : (
							<>
								<EmptyText width={'226px'} />
								<EmptyText width={'183px'} />
							</>
						)}
					</TitleContainer>
					{!loading ? (
						<>
							{icon && (
								<IconContainer
									onClick={handleAction}
									hasAction={handleAction ? true : false}
								>
									{icon}
								</IconContainer>
							)}
						</>
					) : (
						<EmptyIcon />
					)}
				</ActionContainer>
			</Container>
		</CardContainer>
	);
};
